"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        hoverDefault: {
            '.hoverable:hover & path': {
                fill: "".concat(theme_1.default.textColors.highlight, " !important"),
            },
        },
        expanded: {
            transform: 'rotate(180deg)',
            transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
        collapsed: {
            transform: 'rotate(0deg)',
            transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
    });
});
